import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { companyInfo } from '../mock';

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <span className="px-6 py-2 bg-black text-white rounded-full text-sm font-semibold tracking-wider uppercase inline-block mb-4">
            Get In Touch
          </span>
          <h2 className="text-5xl md:text-6xl font-extrabold text-black mb-6 tracking-tight">
            Contact Us
          </h2>
          <p className="text-xl text-gray-600 font-light">
            Get in touch with us for any inquiries or project discussions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white rounded-3xl p-10 border-0 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 text-center group">
            <div className="w-20 h-20 bg-gradient-to-br from-gray-900 to-black rounded-2xl mx-auto mb-6 flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-xl">
              <Phone className="w-9 h-9 text-white" />
            </div>
            <h3 className="text-2xl font-extrabold text-black mb-4">Phone</h3>
            <p className="text-gray-700 text-lg font-semibold mb-2">{companyInfo.phone}</p>
            <p className="text-gray-700 text-lg font-semibold mb-4">{companyInfo.alternatePhone}</p>
            <p className="text-gray-500 text-sm font-light">Mon - Sat: 9:00 AM - 7:00 PM</p>
          </div>

          <div className="bg-white rounded-3xl p-10 border-0 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 text-center group">
            <div className="w-20 h-20 bg-gradient-to-br from-gray-900 to-black rounded-2xl mx-auto mb-6 flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-xl">
              <Mail className="w-9 h-9 text-white" />
            </div>
            <h3 className="text-2xl font-extrabold text-black mb-4">Email</h3>
            <p className="text-gray-700 text-lg font-semibold mb-4">{companyInfo.email}</p>
            <p className="text-gray-500 text-sm font-light">We'll respond within 24 hours</p>
          </div>

          <div className="bg-white rounded-3xl p-10 border-0 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 text-center group">
            <div className="w-20 h-20 bg-gradient-to-br from-gray-900 to-black rounded-2xl mx-auto mb-6 flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-xl">
              <MapPin className="w-9 h-9 text-white" />
            </div>
            <h3 className="text-2xl font-extrabold text-black mb-4">Location</h3>
            <p className="text-gray-700 text-lg font-semibold leading-relaxed">{companyInfo.address}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;